import { graphql, HttpResponse } from 'msw'
import { type EnrollmentJointNextStepDisclosuresData } from '../../../../models'

export const getEnrollmentJointNextStepDisclosuresDataMock: EnrollmentJointNextStepDisclosuresData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/joint/next-step-disclosures',
}

export const mockGetEnrollmentJointNextStepDisclosuresData = graphql.mutation(
  'getEnrollmentJointNextStepDisclosuresData',
  () => {
    return HttpResponse.json({ data: { submitEnrollment: getEnrollmentJointNextStepDisclosuresDataMock } })
  },
)

export const mockEnrollmentJointNextStepDisclosures = [mockGetEnrollmentJointNextStepDisclosuresData]
